import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { $getRoot } from "lexical";
import { useMemo } from "react";
import { useFlags } from "../../../../server/optimizely";
import { $isDynamicContentNode } from "../nodes/dynamic-content/dynamic-content-node";
import { $findAllNodesOfType } from "./find-all-nodes-of-type";

export function useDynamicContent(): boolean {
  const [editor] = useLexicalComposerContext();

  const {
    flags: { dynamic_content },
  } = useFlags("dynamic_content");

  const hasNodes = useMemo(() => {
    let present = false;

    editor.update(
      () => {
        present = $findAllNodesOfType($getRoot(), $isDynamicContentNode).length > 0;
      },
      { discrete: true },
    );

    return present;
  }, [editor]);

  return dynamic_content || hasNodes;
}
